var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384.97 384.97",
    style: {
      enableBackground: "new 0 0 384.97 384.97"
    },
    xmlSpace: "preserve",
    fill: "#424754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.485 0C86.185 0 0 86.173 0 192.485c0 106.3 86.185 192.485 192.485 192.485 106.312 0 192.485-86.185 192.485-192.485C384.97 86.173 298.797 0 192.485 0zm0 360.909c-93.018 0-168.424-75.406-168.424-168.424S99.467 24.061 192.485 24.061s168.424 75.406 168.424 168.424-75.406 168.424-168.424 168.424z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m268.095 209.243-63.46 62.558V84.212c0-6.641-5.438-12.03-12.151-12.03s-12.151 5.39-12.151 12.03v187.589l-63.46-62.558c-4.74-4.692-12.439-4.692-17.179 0-4.74 4.704-4.74 12.319 0 17.011l84.2 82.997c2.25 2.25 5.414 3.537 8.59 3.537 3.164 0 6.328-1.299 8.59-3.525l84.2-82.997a11.942 11.942 0 0 0 0-17.011c-4.739-4.704-12.439-4.704-17.179-.012z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/DownloadIcon.c23456c73a93a124a51f1f569afd5d48.svg";
export { ForwardRef as ReactComponent };